import { useTheme } from "@mui/material";
import { GridProps } from "@mui/material/Grid";
import { SxProps } from "@mui/system";

interface ModalStylingOptions {
  isMobile: boolean;
  theme: ReturnType<typeof useTheme>;
}

export const modalStyling = ({ isMobile, theme }: ModalStylingOptions) => {
  const modalSx: SxProps = {
    alignItems: "center",
    justifyContent: "center",
    overflow: "auto"
  };

  const modalContentSx: SxProps = {
    height: isMobile ? "80vh" : "70vh",
    justifyContent: "flex-start",
    padding: "1rem",
    overflow: "auto"
  };

  const modalOverlaySx: SxProps = {
    maxWidth: isMobile ? "95vw" : "500px", // More narrow modal
    width: "100%",
    maxHeight: "90vh",
    borderRadius: 2,
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
    backgroundColor: "#ffffff",
    overflow: "hidden"
  };

  const messageContainerProps: GridProps = {
    overflow: "auto",
    height: "auto",
    width: "100%",
    spacing: 2,
    sx: {
      padding: 2,
      paddingTop: 1
    }
  };

  return {
    modalSx,
    modalContentSx,
    modalOverlaySx,
    messageContainerProps
  };
};

export const filterFieldStyles = {
  container: {
    marginBottom: "1rem"
  },
  label: {
    fontSize: "0.875rem",
    fontWeight: 500,
    marginBottom: "0.5rem",
    color: "#333"
  },
  rangeContainer: {
    padding: "0 1rem"
  },
  dateContainer: {
    display: "flex",
    flexDirection: "row",
    gap: "0.5rem",
    alignItems: "center",
    flexWrap: "wrap"
  }
};
